import React from 'react';
import styled from 'styled-components';

const StyledText = styled.h2`
  font-size: 30px;
  line-height: 40px;
  font-weight: 900;
  padding: 0;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 30px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const LargText = ({ text }) => {
  return <StyledText>{text}</StyledText>;
};

export default LargText;
